import React from "react";
import {
  FileText,
  Shield,
  Lock,
  AlertCircle,
  Mail,
  ArrowLeft,
} from "lucide-react";
import { Footer } from "./Footer";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-white shadow-sm border-b border-border">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="w-full flex justify-between items-center h-16">
            {/* Back Button on Left End */}
            <button
              onClick={() => {
                navigate('/');
              }}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-lg font-medium">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          // minHeight: "100vh",
          backgroundColor: "#fef2f2",
          // padding: "2rem 0 4rem",
          marginTop: "5vh",
        }}
      >
        <div
          style={{
            width: "90%",
            // maxWidth: "800px",
            margin: "auto",
            marginBottom: "10vh",
            backgroundColor: "white",
            padding: "3rem",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
          }}
        >
          {/* Header */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "3rem",
              paddingBottom: "2rem",
              borderBottom: "2px solid #fee2e2",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "12px",
                marginBottom: "1rem",
              }}
            >
              <div
                style={{
                  padding: "12px",
                  borderRadius: "12px",
                  background:
                    "linear-gradient(135deg, #e74343ff 0%, #e34c90ff 100%)",
                  color: "white",
                }}
              >
                <FileText size={28} />
              </div>
              <h1
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "700",
                  background:
                    "linear-gradient(135deg, #e74343ff 0%, #e34c90ff 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  margin: 0,
                }}
              >
                Terms & Conditions
              </h1>
            </div>

            <p
              style={{
                fontSize: "1rem",
                color: "#666",
                maxWidth: "600px",
                margin: "0 auto",
                lineHeight: "1.6",
              }}
            >
              Last Updated:{" "}
              {new Date().toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>

          {/* Safety Notice */}
          <div
            style={{
              backgroundColor: "#fef3c7",
              borderLeft: "4px solid #f59e0b",
              padding: "1.25rem",
              borderRadius: "8px",
              marginBottom: "2.5rem",
              display: "flex",
              gap: "12px",
              alignItems: "flex-start",
            }}
          >
            <AlertCircle size={20} color="#92400e" />
            <div>
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#92400e",
                  margin: "0",
                  fontWeight: "500",
                  lineHeight: "1.6",
                }}
              >
                For your safety, we strongly recommend meeting in public places,
                informing family members, and avoiding financial transactions
                with other members.
              </p>
            </div>
          </div>

          {/* Content Sections */}
          <div>
            {[
              {
                title: "1. Introduction",
                content:
                  "These Terms & Conditions govern your use of the AvanAval matrimony platform, including website and mobile application , owned and operated by AvanAval Team. By accessing or using our Services, you agree to be bound by these Terms.",
              },
              {
                title: "2. Eligibility",
                content: "",
                list: [
                  "Users must be 18 years or older.",
                  "Users confirm they are legally free to marry as per Indian laws.",
                  "Profiles must be created only for self or with explicit permission of the profile owner.",
                ],
              },
              {
                title: "3. Account Creation & Verification",
                content:
                  "You are responsible for maintaining the confidentiality of your account and login details. The information provided must be true, current, and accurate. We may verify identity, but it is not guaranteed. Users are advised to independently verify before making commitments.",
              },
              {
                title: "4. User Responsibilities",
                content: "You agree NOT to:",
                list: [
                  "Post or share offensive, pornographic, defamatory, or abusive content.",
                  "Create fake profiles or impersonate others.",
                  "Request or demand money from users.",
                  "Use our platform for dating, friendship, business promotion, or illegal activities.",
                  "Collect personal data of other users without consent.",
                ],
                note: "Violation of these may result in immediate account termination.",
              },
              {
                title: "5. Communication & Chat Policy",
                content:
                  "Messaging and contact features must be used respectfully. Any harassment, threats, or exploitation may lead to legal action. Users must report suspicious profiles to AvanAval.",
              },
              {
                title: "6. Subscription & Payment",
                content:
                  "Subscription plans provide additional features and access. Payments are processed through Razorpay. Once a subscription is purchased, it is non-refundable, except as required by law. AvanAval does not guarantee engagement or marriage.",
              },
              {
                title: "7. Content Rights & Profile Information",
                content:
                  "Users grant AvanAval a license to display their photos and details within the platform. Users are responsible for copyrights of the content they upload.",
              },
              {
                title: "8. Safety & User Interaction",
                content:
                  "AvanAval does not verify all user backgrounds. All communications and interactions are at your own risk. We strongly recommend:",
                list: [
                  "Meeting in public places",
                  "Informing family before commitments",
                  "Avoiding money transfers to unknown people",
                ],
                note: "AvanAval is not responsible for: Fraud or misconduct by users. Any relationship or marriage outcomes.",
              },
              {
                title: "9. Account Suspension & Termination",
                content:
                  "AvanAval may suspend or delete accounts for violation of these Terms, on user request, or due to inactivity or technical requirements. Users may delete their account anytime, resulting in permanent removal of personal data as per our Privacy Policy.",
              },
              {
                title: "10. Intellectual Property",
                content:
                  "All content, trademarks, and technology in the Services are owned by AvanAval.",
              },
              {
                title: "11. Limitation of Liability",
                content:
                  "AvanAval is not liable for damages arising from misuse of the platform, data loss due to technical issues, or misrepresentation by users. Our maximum liability shall not exceed the subscription amount paid.",
              },
              {
                title: "12. Governing Law & Dispute Resolution",
                content:
                  "These Terms are governed by the laws of India. Any dispute will be handled exclusively in Courts in India.",
              },
              {
                title: "13. Amendments",
                content:
                  "AvanAval may update these Terms at any time. Continued use means acceptance of updated Terms.",
              },
            ].map((section, index) => (
              <div
                key={index}
                style={{
                  padding: "1.75rem 0",
                  borderBottom: index === 12 ? "none" : "1px solid #f0f0f0",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    color: "#1f2937",
                    marginBottom: "0.75rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "28px",
                      height: "28px",
                      backgroundColor: "#fee2e2",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#dc2626",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                    }}
                  >
                    {index + 1}
                  </span>
                  {section.title.split(" ").slice(1).join(" ")}
                </h2>

                {section.content && (
                  <p
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      color: "#4b5563",
                      marginBottom: section.list ? "0.75rem" : "0",
                    }}
                  >
                    {section.content}
                  </p>
                )}

                {section.list && (
                  <ul
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.7",
                      color: "#4b5563",
                      paddingLeft: "1.5rem",
                      margin: "0 0 1rem 0",
                    }}
                  >
                    {section.list.map((item, idx) => (
                      <li key={idx} style={{ marginBottom: "0.5rem" }}>
                        {item}
                      </li>
                    ))}
                  </ul>
                )}

                {section.note && (
                  <div
                    style={{
                      backgroundColor: "#f8fafc",
                      borderLeft: "3px solid #94a3b8",
                      padding: "1rem",
                      borderRadius: "6px",
                      marginTop: "1rem",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "0.95rem",
                        lineHeight: "1.6",
                        color: "#475569",
                        margin: "0",
                        fontStyle: "italic",
                      }}
                    >
                      {section.note}
                    </p>
                  </div>
                )}
              </div>
            ))}

          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsAndConditions;
